import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@mui/material/styles';
import { FlexBox, Typography, useMediaQuery } from 'ml-rubiks-styleguide';
import { injectTSDI } from 'ml-webclient-common/src/tsdi';
import { I18nStore } from '../../core/i18n';
export function DirectDebitDetails({ directDebit }) {
    const i18n = injectTSDI(I18nStore);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const rows = [
        {
            label: i18n.__('ffl.update.payment.method.iban'),
            value: directDebit.iban
        },
        {
            label: i18n.__('ffl.update.payment.method.account.holder'),
            value: directDebit.accountHolder
        }
    ].filter((row) => row.value);
    if (isMobile) {
        return (_jsx(FlexBox, { stack: true, sx: { mb: 2 }, children: rows.map((row) => (_jsxs(FlexBox, { stack: true, sx: { mb: 1.5 }, children: [_jsx(Typography, { variant: "body1", color: "text.secondary", children: row.label }), _jsx(Typography, { variant: "body1", fontWeight: 600, children: row.value })] }, row.label))) }));
    }
    // Desktop: two-column layout (labels left, values right)
    return (_jsxs(FlexBox, { gap: 4, sx: { mb: 2 }, children: [_jsx(FlexBox, { stack: true, children: rows.map((row) => (_jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 0.5 }, children: row.label }, row.label))) }), _jsx(FlexBox, { stack: true, children: rows.map((row) => (_jsx(Typography, { variant: "body1", fontWeight: 600, sx: { mb: 0.5 }, children: row.value }, row.label))) })] }));
}
